import { CHANGETHEME } from "./darkmode.types";

const INITIAL_STATE = {
  theme: "light",
};

const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case CHANGETHEME: {
      if (state.theme === "light") {
        return {
          ...state,
          theme: "dark",
        };
      } else {
        return {
          ...state,
          theme: "light",
        };
      }
    }

    default:
      return state;
  }
};

export default reducer;
